import { Divider, Menu, Tooltip, Typography } from '@mui/material';
import { fontSize, palette } from '../..';
import { useDispatch } from 'react-redux';
import {
  deleteItemInChartProp,
  parameterizedChartProperty,
  reorderParameterizedCharts,
  updateAxesQueryParam,
  updateFilterSetParameter,
} from '../../redux/ChartPoperties/ChartPropertiesActions';
import { useMemo, useState, useEffect } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import moment from 'moment';
import { useGetActions } from './FetchFilterData';
import {
  deleteRightFilterGroupItems,
  setLastModifiedFilter,
  updateChartFilterRightGroupsFilters,
} from '../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import FilterMenuOptions from './FilterMenuOptions';
import { fieldProps, IDsInfo } from '../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { deleteFilterFromParameter } from '../../redux/Parameters/ParametersAction';
import { callQueryAPI, SetModifyOptions } from '../../redux/ChartPoperties/ChartControlsActions';
import { IChartFIlter } from '../ChartFilterGroup/interfaces';
import { callQueryAPIDashboard } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { getAggregation } from './utils';
import Aggregators, { AggregatorKeys } from '../ChartAxes/Aggregators';
import AggregationMenuItem from '../ChartAxes/Card/AggregationMenuItem';
import { checkIfMissingColumn } from '../CommonFunctions/CommonFunctions';
import Warning from '@mui/icons-material/WarningAmber';
import SourceDetails from '../ChartAxes/Card/SourceDetails';

interface IFilterFieldProps {
  field: fieldProps;
  filterFieldData: any;
  propKey: string;
  token: string;
  uID?: string;
  itemIndex: number;
  bIndex: number;
  name?: string;
  setCirLoading: (loading: boolean) => void;
  setLoading: (loading: boolean) => void;
  totalFiltersInGroup?: number;
  from?: string;
  dsInfo?: IDsInfo;
  color?: string;
  backgroundColor?: string;
  syncFilterEnabled?: boolean;
  triggerSyncFilterDataFetch?: (
    calledByFilter: IChartFIlter,
    isLastModified?: boolean,
  ) => Promise<void>;
}

let menuStyle = { fontSize: '12px', padding: '2px 1.5rem' };
let menuSelectedStyle = {
  fontSize: '12px',
  padding: '2px 1.5rem',
  backgroundColor: 'rgba(175, 153, 219,0.3)',
  '&:hover': {
    backgroundColor: 'rgba(175, 153, 219, 0.5)',
  },
};
///Reder Filter Fields
export const FilterField = ({
  field,
  filterFieldData,
  propKey,
  token,
  uID,
  itemIndex,
  bIndex,
  name = '',
  setCirLoading,
  setLoading,
  totalFiltersInGroup = 0,
  from = 'chartFilter',
  dsInfo,
  syncFilterEnabled,
  triggerSyncFilterDataFetch,
  color,
  backgroundColor,
}: IFilterFieldProps) => {
  const {
    savedParameters,
    chartProperties,
    chartControls,
    tabTileProps,
    savedCalcs,
    chartGroup,
    dashMode,
    showDash,
    callQueryAPIForDashboard,
    dashBoardGroup,
  } = useSelector((state: RootState) => {
    return {
      savedParameters: state.parameters.savedParameters,
      chartProperties: state.chartProperties.properties[propKey],
      chartControls: state.chartControls,
      tabTileProps: state.tabTileProps,
      savedCalcs: state.calculations.savedCalculations,
      chartGroup: state.chartFilterGroup,
      dashMode: state.tabTileProps.dashMode,
      showDash: state.tabTileProps.showDash,
      callQueryAPIForDashboard: state.tabTileProps.callQueryAPIDashboard,
      dashBoardGroup: state.dashBoardFilterGroup,
    };
  });

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [parameterized, setParameterized] = useState(filterFieldData.isParameterized);
  const [showSourceDetails, setShowSourceDetails] = useState<boolean>(false);
  const [anchorEl2, setAnchorEl2] = useState<any | null>(null);

  let aggr: { name: string; id: string }[] = [];
  let timeGrains: { name: string; id: string }[] = [];
  if (['timestamp', 'date'].includes(field.dataType)) {
    aggr = aggr.concat(Aggregators['Filter'][field.dataType].aggr);
    timeGrains = timeGrains.concat(Aggregators['Filter'][field.dataType].timeGrain);
  } else aggr = aggr.concat(Aggregators['Filter'][field.dataType]);
  let currentChartAxesName = uID ? 'chartAxes_' + uID : 'chartAxes';
  const baseOptions = ['Pick List'];
  const forBoolean = ['boolean'].includes(filterFieldData.dataType?.toLowerCase());

  const dateOptions = ['timestamp', 'date'].includes(filterFieldData.dataType)
    ? ['Relative Filter']
    : [];

  const chartOptions = from === 'chartFilter' ? ['Top N'] : [];
  const boolanOptions = !forBoolean
    ? from === 'chartFilter'
      ? ['Search Condition', 'Aggregate Condition']
      : ['Search Condition']
    : [];

  const filterOptions = filterFieldData.isAggregated
    ? ['Aggregate Condition', 'Top N']
    : [...baseOptions, ...boolanOptions, ...chartOptions, ...dateOptions];

  const selectedDs = useMemo(() => {
    return chartProperties.selectedDs;
  }, [chartProperties.selectedDs.id]);

  // Handle missing column check which may return a Promise<boolean>
  const [isShowWarning, setIsShowWarning] = useState<boolean>(false);

  const { GetPickListItems, GetRelativeFilterItems } = useGetActions({
    sortOptions: [],
    filterFieldData,
    field,
    propKey,
    token,
    uID,
    itemIndex,
    name,
    from,
    dsInfo,
  });

  const [selectedSortOptions, setSelectedSortOptions] = useState<string[]>(
    filterFieldData['previousSortOptions']
      ? JSON.parse(filterFieldData['previousSortOptions'])
      : [],
  );

  const callAPI = () => {
    if (!uID || from !== 'chartFilter') {
      if (showDash) {
        Object.keys(chartGroup.tabTile).forEach((tabTileId: string) => {
          if (dashBoardGroup.filterGroupTabTiles[name].includes(tabTileId)) {
            dispatch(callQueryAPI(tabTileId, true));
          }
        });
      }
      Object.entries(chartGroup.tabTile).forEach(([tabTileId, arr]: any) => {
        if (arr.includes(name)) {
          dispatch(callQueryAPI(tabTileId, true));
          if (!callQueryAPIForDashboard) dispatch(callQueryAPIDashboard(true));
        }
      });
      dispatch(callQueryAPI(propKey, true));
      if (showDash && !callQueryAPIForDashboard) dispatch(callQueryAPIDashboard(true));
    }
  };

  ///Initialize Relative Filter items
  const initialRelativeFilterData = () => {
    if (!filterFieldData.expTypeFromdate) {
      filterFieldData['expTypeFromdate'] = 'year';
    }
    if (!filterFieldData.expTypeTodate) {
      filterFieldData['expTypeTodate'] = 'day';
    }
    if (!filterFieldData.expTypeFromRelativeDate) {
      filterFieldData['expTypeFromRelativeDate'] = 'last';
    }
    if (!filterFieldData.expTypeToRelativeDate) {
      filterFieldData['expTypeToRelativeDate'] = 'last';
    }
    if (!filterFieldData.expTypeAnchorDate) {
      filterFieldData['expTypeAnchorDate'] = 'today';
    }
    if (!filterFieldData.exprInputFromValueType) {
      filterFieldData['exprInputFromValueType'] = 2;
    }
    if (!filterFieldData.exprInputToValueType) {
      filterFieldData['exprInputToValueType'] = 2;
    }
    if (!filterFieldData.exprInputSpecificDate) {
      filterFieldData['exprInputSpecificDate'] = moment(new Date()).format('YYYY-MM-DD');
    }
  };
  const disable = useMemo(() => {
    // const dimensions = chartProperties?.[currentChartAxesName]?.[0]?.fields || [];
    const axesToPick = ['Row', 'Column', 'Dimension'];

    const dimensions = (chartProperties?.[currentChartAxesName] || [])
      .filter((axis: any) => axesToPick.includes(axis.name))
      .flatMap((axis: any) => axis.fields || []);
    return dimensions.length === 0;
  }, [chartProperties?.[currentChartAxesName]]);
  ///Initial Search Condition Values
  const initialSearchConditionValues = () => {
    if (filterFieldData.fieldtypeoption === 'Search Condition') {
      if (filterFieldData.dataType) {
        switch (filterFieldData.dataType) {
          case 'decimal':
          case 'integer':
            if (!filterFieldData.exprType) {
              filterFieldData['exprType'] = 'greaterThan';
            }
            break;
          case 'text':
            if (!filterFieldData.exprType) {
              filterFieldData['exprType'] = 'beginsWith';
            }
            break;
          case 'timestamp':
          case 'date':
            if (!filterFieldData.exprType) {
              filterFieldData['prefix'] = 'year';
              filterFieldData['exprType'] = 'greaterThan';
            }
            break;
          default:
            if (!filterFieldData.exprType) {
              filterFieldData['exprType'] = 'greaterThan';
            }
            break;
        }
      }
    }
  };

  ///Handle Menu button on click
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  ///Remove filter card from dropzone
  const deleteItem = () => {
    if (from === 'chartFilter') {
      // Reorder parameterized chart filters based on the order of fields in chartProperties
      const chartFields = chartProperties?.[currentChartAxesName]?.[0]?.fields || [];
      chartFields.forEach((fieldItem: any) => {
        const parameterId = fieldItem.parameterId;
        if (!parameterId) return;

        savedParameters.forEach((param: any) => {
          if (
            param.parameterId === parameterId &&
            Array.isArray(param.chartFilter) &&
            param.chartFilter.length > 0
          ) {
            // Find all filters for this chartAxes
            const chartFilters = param.chartFilter.filter(
              (cf: any) => cf.currentChartAxesName === currentChartAxesName,
            );
            if (chartFilters.length > 0) {
              const updatedChartFilters = param.chartFilter.map((cf: any) => {
                if (cf.currentChartAxesName === currentChartAxesName && cf.itemIndex > itemIndex) {
                  return { ...cf, itemIndex: cf.itemIndex - 1 };
                }
                return cf;
              });
              dispatch(reorderParameterizedCharts(propKey, param.parameterId, updatedChartFilters));
            }
          }
        });
      });

      dispatch(updateAxesQueryParam(propKey, bIndex, itemIndex, field, currentChartAxesName));
      dispatch(deleteItemInChartProp(propKey, bIndex, itemIndex, currentChartAxesName));
      dispatch(deleteFilterFromParameter(propKey, field.uId as string, currentChartAxesName));
      dispatch(SetModifyOptions(propKey, uID ? 'filter_override_open' : 'axis', null));
    } else if (from === 'reportFilter') {
      //to restric deletecard action when in dashboard present mode
      if (dashMode === 'Edit') {
        const lastEditedFilter =
          totalFiltersInGroup === 1 ? null : chartGroup.groups[name]?.filters[0].uId;
        dispatch(setLastModifiedFilter(name, lastEditedFilter));
        dispatch(deleteRightFilterGroupItems(name, itemIndex));
      }
    }
    if (filterFieldData.fieldtypeoption === 'Pick List') {
      if (
        !filterFieldData.userSelection ||
        (!filterFieldData.userSelection.includes('(All') &&
          filterFieldData.userSelection.length > 0)
      ) {
        callAPI();
      }
    }
    if (filterFieldData.fieldtypeoption === 'Search Condition') {
      if (filterFieldData.exprInput) {
        callAPI();
      }
    }
    if (filterFieldData.fieldtypeoption === 'Relative Filter') {
      callAPI();
    }
    if (['Aggregate Condition', 'Top N'].includes(filterFieldData.fieldtypeoption))
      dispatch(callQueryAPI(propKey, true));
    /**irr-respective of changes  filter or filtergroup if any is deleted we need to call the API */
    if (from === 'reportFilter' && syncFilterEnabled && totalFiltersInGroup > 1) {
      triggerSyncFilterDataFetch?.(filterFieldData, false);
    } else dispatch(SetModifyOptions(propKey, 'axis', null));
  };

  ///Expand Collapse Icon switch
  const ExpandCollaseIconSwitch = () => {
    return filterFieldData.isCollapsed ? (
      <ChevronRightIcon
        style={{
          height: '18px',
          width: '18px',
          color: color || palette.primary.contrastText,
        }}
        onClick={(e) => {
          filterFieldData.isCollapsed = false;
          if (from === 'chartFilter') {
            dispatch(
              updateAxesQueryParam(
                propKey,
                0,
                itemIndex,
                filterFieldData,
                currentChartAxesName,
                false,
              ),
            );
          } else if (from === 'reportFilter') {
            dispatch(updateChartFilterRightGroupsFilters(name, filterFieldData, false));
          }
        }}
      />
    ) : (
      <KeyboardArrowDownIcon
        style={{
          height: '18px',
          width: '18px',
          color: color || palette.primary.contrastText,
        }}
        onClick={(e) => {
          filterFieldData.isCollapsed = true;
          if (from === 'chartFilter') {
            dispatch(
              updateAxesQueryParam(
                propKey,
                0,
                itemIndex,
                filterFieldData,
                currentChartAxesName,
                false,
              ),
            );
          } else if (from === 'reportFilter') {
            dispatch(updateChartFilterRightGroupsFilters(name, filterFieldData, false));
          }
        }}
      />
    );
  };

  const checkForValidData = () => {
    if (filterFieldData.exprType === 'blank') return true;
    else if (
      filterFieldData.prefix === 'date' &&
      new Date(filterFieldData.greaterThanOrEqualTo) > new Date(filterFieldData.lessThanOrEqualTo)
    ) {
      filterFieldData['isInValidData'] = true;
    } else {
      if (
        parseInt(filterFieldData.greaterThanOrEqualTo) > parseInt(filterFieldData.lessThanOrEqualTo)
      ) {
        filterFieldData['isInValidData'] = true;
      }
    }
  };
  const handleOpenAggregationMenu = (e: any) => setAnchorEl2(e.currentTarget);
  ///Menu close event handler
  //todo:: tobe completed later
  // const validFilter = (filterFieldData: any) => {
  //   let isValidPicklist = false;
  //   let isValidSearchCondition = false;
  //   let isValidRelativeFilter = false;
  //   let isValidAggregateCondition = false;
  //   let isvalidTopN = false;
  // };
  /**
   * 'opt2'---> filter Type(PickList,Search Condition,Relative Filter,Aggregate Condition(new03/12/25),Top N(new 03/12/25))
   *
   * 'opt1'---> Include/Exclude
   *
   *
   */
  //todo:: modify handle close  code iscomplex  need to refactor
  const handleClose = async (closeFrom: 'opt1' | 'opt2' | 'clickOutside', queryParam?: string) => {
    let isAPICallNeeded = false;
    filterFieldData.callAPI = false;
    const length = filterFieldData.userSelection?.length ?? 0;

    setAnchorEl(null);
    const old_filter_type = filterFieldData.fieldtypeoption;
    let validSearchCondition = false;
    let validPicklist = false;
    if (['Search Condition', 'Aggregate Condition'].includes(filterFieldData.fieldtypeoption)) {
      if (
        filterFieldData.exprType === 'between' &&
        filterFieldData.greaterThanOrEqualTo &&
        filterFieldData.lessThanOrEqualTo
      )
        validSearchCondition = true;
      else if (filterFieldData.exprInput) validSearchCondition = true;
    }
    if (filterFieldData.fieldtypeoption === 'Pick List' && length > 0) validPicklist = true;
    if (closeFrom === 'opt2') {
      filterFieldData['exprInput'] = '';
      initialRelativeFilterData();
      if (queryParam === 'Pick List') filterFieldData.exprType = 'in';
      else if (queryParam === 'Search Condition')
        filterFieldData.exprType = ['integer', 'decimal'].includes(filterFieldData.dataType)
          ? 'greaterThan'
          : filterFieldData.dataType === 'date' || filterFieldData.dataType === 'timestamp'
            ? 'greaterThan'
            : 'beginsWith';

      if (
        filterFieldData.fieldtypeoption === 'Pick List' &&
        ['Search Condition', 'Aggregate Condition', 'Top N'].includes(queryParam ?? '')
      ) {
        if (filterFieldData.userSelection?.length > 0) {
          filterFieldData.callAPI = true;
          isAPICallNeeded = true;
        }
      } else if (
        ['Search Condition', 'Aggregate Condition'].includes(filterFieldData.fieldtypeoption) &&
        queryParam === 'Pick List' &&
        validSearchCondition
      ) {
        filterFieldData.callAPI = true;
        isAPICallNeeded = true;
        filterFieldData['exprInput'] = '';
      }
      if (!filterFieldData.rawselectmembers || filterFieldData.fieldtypeoption !== queryParam) {
        filterFieldData['fieldtypeoption'] = queryParam;

        if (queryParam === 'Pick List') {
          filterFieldData.userSelection = [];
          setLoading(true);
          await GetPickListItems();
          setLoading(false);
        }
        if (queryParam === 'Relative Filter') {
          setCirLoading(true);
          await GetRelativeFilterItems();
          setCirLoading(false);
        }
      }

      filterFieldData['fieldtypeoption'] = queryParam;

      if (filterFieldData.fieldtypeoption === 'Pick List') {
        filterFieldData['userSelection'] = [];
        filterFieldData.isInValidData = false;
        filterFieldData.filterTypeTillDate = 'enabled';
        filterFieldData.exprTypeTillDate = false;
      } else if (filterFieldData.fieldtypeoption === 'Search Condition') {
        initialSearchConditionValues();
        filterFieldData.exprTypeTillDate = false;
        checkForValidData();
      } else {
        filterFieldData.includeexclude = 'Include';
      }
    } else if (closeFrom === 'opt1') {
      if (queryParam === filterFieldData.includeexclude) return;
      isAPICallNeeded = true;
      if (
        filterFieldData.fieldtypeoption === 'Pick List' &&
        filterFieldData.userSelection.includes('(All)')
      ) {
        filterFieldData['userSelection'] = [];
        isAPICallNeeded = false;
      }
      filterFieldData.includeexclude = queryParam;
      if (filterFieldData.fieldtypeoption === 'Relative Filter') {
        filterFieldData.includeexclude = 'Include';
      }
    } else {
      if (filterFieldData.fieldtypeoption === 'Relative Filter') {
        setCirLoading(true);
        await GetRelativeFilterItems();
        setCirLoading(false);
      }
    }
    if (old_filter_type === 'Relative Filter' && queryParam !== 'Relative Filter') {
      filterFieldData.callAPI = true;
      isAPICallNeeded = true;
    }
    if (from === 'chartFilter') {
      if (['Aggregate Condition', 'Top N'].includes(queryParam ?? '')) {
        filterFieldData.aggr = getAggregation(filterFieldData.dataType);
        filterFieldData.userSelection = [];

        if (['RelativeFilter', 'Pick List', 'Top N'].includes(old_filter_type)) {
          filterFieldData.callAPI =
            'pick List' === old_filter_type ? (length > 0 ? true : false) : true;
          isAPICallNeeded = 'pick List' === old_filter_type ? (length > 0 ? true : false) : true;
        } else if (
          ['Search Condition', 'Aggregate Condition'].includes(old_filter_type) &&
          validSearchCondition
        ) {
          filterFieldData.callAPI = true;
          isAPICallNeeded = true;
        }
        // setParameterized(false);
        // if (filterFieldData.isParameterized)
        //   dispatch(deleteFilterFromParameter(propKey, filterFieldData.uId, currentChartAxesName));
      }
      if (queryParam === 'Top N') {
        filterFieldData.exprType = 'descending';
        filterFieldData.exprInput = '';
      } else if (queryParam === 'Aggregate Condition') {
        filterFieldData['exprType'] = 'greaterThan';
        filterFieldData['exprInput'] = '';
      }

      /***few conversions handled seperatedly  below  and it only cheks api call needed or not  */

      if (
        old_filter_type === 'Aggregate Condition' &&
        ['Pick List', 'Search Condition'].includes(queryParam ?? '')
      ) {
        if (validSearchCondition) {
          filterFieldData.callAPI = true;
          isAPICallNeeded = true;
        }
      } else if (old_filter_type === 'Aggregate Condition' && queryParam === 'Top N') {
        filterFieldData.callAPI = true;
        isAPICallNeeded = true;
      } else if (old_filter_type === 'Top N') {
        filterFieldData.callAPI = true;
        isAPICallNeeded = true;
      }
    }
    if (from === 'chartFilter') {
      if (queryParam !== 'Relative Filter')
        dispatch(
          updateAxesQueryParam(propKey, 0, itemIndex, filterFieldData, currentChartAxesName),
        );
    } else if (from === 'reportFilter') {
      filterFieldData['previousSortOptions'] = JSON.stringify([]);
      // if (queryParam !== "Pick List")
      if (
        queryParam !== 'Relative Filter' ||
        (old_filter_type === 'Relative Filter' && !['Pick List'].includes(queryParam))
      )
        dispatch(updateChartFilterRightGroupsFilters(name, filterFieldData));
      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
    }
    if (closeFrom === 'opt2' && filterFieldData.isParameterized) {
      dispatch(deleteFilterFromParameter(propKey, filterFieldData.uId, currentChartAxesName));
      dispatch(
        updateFilterSetParameter(propKey, bIndex, currentChartAxesName, filterFieldData.uId, ''),
      );
    }
    dispatch(
      SetModifyOptions(
        propKey,
        from === 'chartFilter' ? 'filter' : 'filter_group',
        closeFrom === 'clickOutside'
          ? null
          : from === 'chartFilter'
            ? filterFieldData.uId
            : `${name}_${filterFieldData.uId}`,
      ),
    );
    if (isAPICallNeeded) {
      callAPI();
    }
  };
  const handleChangeAggregation = (option: string, type: 'aggr' | 'prefix') => {
    if (from === 'chartFilter') {
      if (type === 'aggr') filterFieldData.aggr = option;
      else filterFieldData.prefix = option;
      setAnchorEl2(null);
      dispatch(SetModifyOptions(propKey, 'filter', filterFieldData.uId));
      dispatch(updateAxesQueryParam(propKey, 0, itemIndex, filterFieldData, currentChartAxesName));
      callAPI();
    }
  };
  const handleOptionSelect = async (section: string, option: string) => {
    if (section === 'opt1') {
      handleClose(section, option);
    } else {
      if (option !== 'Pick List') {
        setSelectedSortOptions([]);
      } else {
        filterFieldData['userSelection'] = [];
        filterFieldData['filterTypeTillDate'] = 'enabled';
        // filterFieldData['exprInput'] = '';
        // await GetPickListItems();
      }
      handleClose('opt2', option);

      if (option === 'Relative Filter') {
        if (from === 'chartFilter') {
          setParameterized(false);
          filterFieldData.isParameterized = false;
          dispatch(
            parameterizedChartProperty(
              propKey,
              bIndex,
              currentChartAxesName,
              filterFieldData,
              false,
            ),
          );
        }
      }
    }
  };

  const handleSortOptionToggle = (sortOpt: string) => {
    const sortOptions = selectedSortOptions.includes(sortOpt)
      ? selectedSortOptions.filter((opt: any) => opt !== sortOpt) // Deselect if already selected
      : [...selectedSortOptions, sortOpt];

    // Always start with the original unfiltered data
    let tempResult = [...filterFieldData.rawselectmembersOriginal];

    // Apply multiple sort options
    if (sortOptions.includes('Sort Desc')) {
      tempResult = [
        '(All)',
        ...tempResult
          .filter((item: any) => item !== '(All)')
          .sort()
          .reverse(),
      ];
    } else {
      tempResult = ['(All)', ...tempResult.filter((item: any) => item !== '(All)').sort()];
    }

    if (sortOptions.includes('Remove Blank')) {
      tempResult = tempResult.filter((val: string) => val !== '(Blank)');
    }

    if (sortOptions.includes('Blank at Bottom')) {
      const blanks = tempResult.filter((val: string) => val === '(Blank)');
      tempResult = tempResult.filter((val: string) => val !== '(Blank)').concat(blanks);
    }

    if (sortOptions.includes('Single Selection')) {
      filterFieldData.isSingleSelection = true;
      filterFieldData.userSelection = [];
    } else {
      filterFieldData.isSingleSelection = false;
    }
    if (sortOpt === 'Single Selection') {
      filterFieldData['callAPI'] = true;
      callAPI();
    }
    // Store the updated sorted data
    filterFieldData.rawselectmembers = [...tempResult];
    filterFieldData.previousSortOptions = JSON.stringify(sortOptions);

    // Update the UI state
    setSelectedSortOptions([...sortOptions]);

    // Trigger an update for the chart
    if (from === 'chartFilter') {
      dispatch(updateAxesQueryParam(propKey, 0, itemIndex, filterFieldData, currentChartAxesName));
    } else if (from === 'reportFilter') {
      dispatch(updateChartFilterRightGroupsFilters(name, filterFieldData));
      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
    }
    dispatch(
      SetModifyOptions(
        propKey,
        from === 'chartFilter' ? 'filter' : 'filter_group',
        ['Remove Blank', 'Single Selection'].includes(sortOpt)
          ? from === 'chartFilter'
            ? filterFieldData.uId
            : `${name}_${filterFieldData.uId}`
          : null,
      ),
    );
  };

  // Parameterize the chart filter properties expect for relative filters
  const parameterizeChatProperty = (triggerApi = true) => {
    if (['Relative Filter'].includes(filterFieldData.fieldtypeoption)) {
      return;
    }
    if (parameterized || filterFieldData?.userSelection?.length > 0) {
      filterFieldData['callAPI'] = true;
    } else {
      filterFieldData['callAPI'] = false;
    }
    setParameterized(!parameterized);
    if (!parameterized || filterFieldData?.userSelection?.length > 0) {
      dispatch(deleteFilterFromParameter(propKey, filterFieldData.uId, currentChartAxesName));
      dispatch(
        updateFilterSetParameter(propKey, bIndex, currentChartAxesName, filterFieldData.uId, ''),
      );
      filterFieldData.userSelection = [];
      dispatch(updateAxesQueryParam(propKey, 0, itemIndex, filterFieldData, currentChartAxesName));
      dispatch(SetModifyOptions(propKey, 'filter', filterFieldData.uId));
    }
    dispatch(
      updateFilterSetParameter(propKey, bIndex, currentChartAxesName, filterFieldData.uId, ''),
    );
    dispatch(
      parameterizedChartProperty(
        propKey,
        bIndex,
        currentChartAxesName,
        filterFieldData,
        !parameterized,
      ),
    );
    if (triggerApi) callAPI(); ///////////////////
    setAnchorEl(null);
  };

  useEffect(() => {
    (async () => {
      // console.log(field);
      if (field?.SavedCalculationUUID) {
        const isSavedCalculation = savedCalcs.find(
          (calculation) =>
            calculation.uuid === field.SavedCalculationUUID &&
            calculation.datasetId === selectedDs.id,
        );
        if (isSavedCalculation) {
          let hasMissing = false;
          // console.log(isSavedCalculation);
          const fields = isSavedCalculation.calculationInfo.fields;
          for (const fieldKey of Object.keys(fields)) {
            try {
              const res = await checkIfMissingColumn(
                fields[fieldKey],
                selectedDs,
                tabTileProps.tablesForSelectedDataSets[selectedDs.id],
              );
              if (res.isMissing) {
                hasMissing = true;
                break;
              }
            } catch (err) {
              hasMissing = true;
              break;
            }
          }
          setIsShowWarning(hasMissing);
        } else {
          setIsShowWarning(true);
        }
        return;
      }
      const res = await checkIfMissingColumn(
        field,
        selectedDs,
        tabTileProps.tablesForSelectedDataSets[selectedDs.id],
        (field as any).originalDataSetId !== selectedDs.id,
      );

      setIsShowWarning(
        (field as any).originalDataSetId !== selectedDs.id
          ? Boolean(!res.newTableId)
          : Boolean(res.isMissing),
      );
    })();
  }, [
    chartProperties.selectedDs?.id,
    chartProperties.chartAxes[bIndex].fields.length,
    chartControls.properties[propKey].chartErrorDetails,
    chartProperties.oldSelectedDs?.id,
  ]);

  return (
    <div
      className={isShowWarning ? 'axisFilterFieldWarning' : 'axisFilterField'}
      style={{
        backgroundColor: backgroundColor,
        ...(!filterFieldData.isCollapsed
          ? {
              border: `1px solid ${color}` || '1px #af99db solid',
              borderRadius: '0px',
              color: '#af99db',
              height: '1.5rem',
            }
          : { height: '1.5rem' }),
      }}
    >
      {/* remove column  */}
      <button
        type="button"
        style={{ color: color }}
        className={`buttonCommon columnClose ${
          from !== 'reportFilter' || dashMode === 'Edit' ? '' : 'disabled disabled-light'
        }`}
        onClick={deleteItem}
        title="Remove field"
      >
        <CloseRoundedIcon
          style={{
            fontSize: fontSize.semiLarge,
            color: color,
            // color: isHovered ? "red" : palette.primary.contrastText,
          }}
        />
      </button>

      {/* filter column name */}
      <>
        <Typography
          variant="body2"
          sx={{
            flexGrow: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: color || palette.primary.contrastText,
            fontSize: fontSize.medium,
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            pt: '2px',
          }}
        >
          <span>{field.displayName2 ?? field.fieldname}</span>
        </Typography>
        {isShowWarning && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              marginRight: '0.5rem',
            }}
          >
            <Tooltip
              arrow
              placement="top"
              title={'This column is missing in the dataset'}
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <Warning
                style={{
                  color: '#850000ff',
                  marginLeft: '5px',
                  opacity: '0.7',
                  flexShrink: 0,
                }}
                fontSize="small"
              />
            </Tooltip>
          </div>
        )}
        {filterFieldData.fieldtypeoption === 'Relative Filter' && !filterFieldData.fromDate && (
          <Tooltip
            title="From and To value can't be empty"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                  mt: '2px',
                },
              },
            }}
          >
            <WarningAmberIcon
              style={{
                color: 'orange',
                marginLeft: '5px',
                marginTop: '-2px',
                opacity: '0.7',
                flexShrink: 0,
                cursor: 'pointer',
              }}
              fontSize="small"
            />
          </Tooltip>
        )}
      </>
      <span
        onClick={handleOpenAggregationMenu}
        style={{
          paddingTop: '3.5px',
          paddingRight: '2px',
          cursor: 'pointer',
          display: !filterFieldData.isAggregated ? 'none' : undefined,
        }}
        className="columnPrefix"
      >
        {filterFieldData.isAggregated ? 'Agg' : null}
      </span>
      {!filterFieldData.isAggregated &&
        ['Aggregate Condition', 'Top N'].includes(filterFieldData.fieldtypeoption) && (
          <span
            onClick={handleOpenAggregationMenu}
            style={{ paddingTop: '3.5px', paddingRight: '2px', cursor: 'pointer' }}
            className="columnPrefix"
          >
            {filterFieldData.aggr ? AggregatorKeys[filterFieldData.aggr] : null}
            {timeGrains.length > 0 ? ',' + AggregatorKeys[filterFieldData.prefix] : null}
          </span>
        )}

      {/* Parameterized Icon */}
      {parameterized && (
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '4px' }}>
          <Tooltip
            title="Parameterized"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <img src="/Parameter_icon.svg" alt="parameter-icon" style={{ height: '0.8rem',aspectRatio:1 }} />
          </Tooltip>
        </div>
      )}

      {/* down arrow icon */}
      <button
        type="button"
        className="buttonCommon"
        style={{ backgroundColor: 'transparent', padding: '1px 0px' }}
        title="More Options"
        onClick={handleClick}
      >
        <MoreVertIcon
          style={{
            fontSize: fontSize.semiLarge,
            color: color || palette.primary.contrastText,
            marginTop: '3px',
            marginRight: '0.5px',
          }}
        />
      </button>

      {/* expand colapse icon */}
      <button
        type="button"
        className="buttonCommon columnDown"
        title={filterFieldData.isCollapsed ? 'Expand' : 'Collapse'}
        style={{
          marginRight: from === 'reportFilter' ? '4px' : '',
          paddingRight: '0',
        }}
      >
        <ExpandCollaseIconSwitch />
      </button>

      <FilterMenuOptions
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose('clickOutside')}
        includeExcludeOptions={['Include', 'Exclude']}
        filterOptions={filterOptions}
        selectedOption={filterFieldData.fieldtypeoption}
        includeExcludeValue={filterFieldData.includeexclude}
        filterType={filterFieldData.fieldtypeoption}
        showPickListOptions={true}
        selectedSortOptions={selectedSortOptions}
        isChartFilter={from}
        onOptionClick={(section: string, value: string) => {
          if (section === 'sort') handleSortOptionToggle(value);
          else handleOptionSelect(section, value);
        }}
        from={from}
        parameterized={parameterized}
        parameterizeChatProperty={parameterizeChatProperty}
        disableAggregated={disable}
        isOverrideFilter={!!uID}
        setShowSourceDetails={setShowSourceDetails}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl2}
        open={!!anchorEl2 && aggr.length > 0}
        onClose={() => setAnchorEl2(null)}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {aggr.length > 0
          ? aggr.map((opt, idx: number) => {
              const aggr = filterFieldData.aggr;
              const isChecked = aggr?.toUpperCase() === opt.id.toUpperCase();
              return (
                <AggregationMenuItem
                  key={opt?.id}
                  isChecked={isChecked}
                  onClick={() => handleChangeAggregation(opt.id, 'aggr')}
                  optionName={opt?.name}
                  isDisabled={
                    filterFieldData.isAggregated && ['timestamp', 'date'].includes(field.dataType)
                  }
                  menuStyle={menuStyle}
                  menuSelectedStyle={menuSelectedStyle}
                />
              );
            })
          : null}

        {timeGrains.length > 0 ? (
          <>
            <Divider />
            {timeGrains.map((opt, idx: number) => {
              const aggr = filterFieldData.prefix;
              const isChecked = aggr?.toUpperCase() === opt.id.toUpperCase();
              // if (['date'].includes(opt.id)) return null;
              return (
                <AggregationMenuItem
                  key={opt?.id}
                  isChecked={isChecked}
                  onClick={() => handleChangeAggregation(opt.id, 'prefix')}
                  optionName={opt?.name}
                  isDisabled={false}
                  menuStyle={menuStyle}
                  menuSelectedStyle={menuSelectedStyle}
                />
              );
            })}
          </>
        ) : null}
      </Menu>
      {showSourceDetails && (
        <SourceDetails field={field} open={showSourceDetails} setOpen={setShowSourceDetails} />
      )}
    </div>
  );
};
